// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261103T231344673Z",
  "builtAt": "2026-11-03T23:13:44.673Z"
} as const;
